(ns frontend.exports.exceljs.coercion
  (:require
   [frontend.utils :as fu]
   [frontend.exports.exceljs.number-formats :as number-formats]
   [common.localization :as loc]
   [frontend.logging :as logging]
   [clojure.string :as string]
   [common.currencies :as currencies]
   [common.util :as cu]
   [common.schema.registry :as registry]
   [frontend.state.current-session :as session]))

(defn millis->excel-date
  [ms]
  (when (and ms (number? ms))
    (-> ms
        (/ (* 1000 60 60 24))
        (+ 25569)
        (float))))

(defn to-excejs-value
  [field-schema value display-string-fn]
  (let [display-text (or (let [d-v (display-string-fn)]
                           (when-not (cu/blank-value? d-v)
                             d-v))
                         value)
        tenant-schema @session/tenant-schema]
    (case (:field/data-type field-schema)
      :data.type/boolean display-text
      :data.type/currency-value (fu/bigdec->float value)
      :data.type/currency-symbol (currencies/get-label value)
      :data.type/datetime (millis->excel-date value)
      :data.type/date (millis->excel-date value)
      :data.type/email-multi display-text
      :data.type/email display-text
      :data.type/financials nil
      :data.type/tesi-financials nil
      :data.type/tesi-financials-2 nil
      :data.type/text display-text
      :data.type/integer value
      :data.type/keyword-multi
      (or (display-string-fn)
          (some->> value
                   (map (fn [a]
                          (let [fs (registry/get-field-schema tenant-schema a)]
                            (loc/field-name a fs))))
                   (string/join "; ")))
      :data.type/keyword (or (display-string-fn)
                             (when (keyword? value)
                               (let [fs (registry/get-field-schema tenant-schema value)]
                                 (loc/field-name value fs))))
      :data.type/long value
      :data.type/number value
      :data.type/percentage value
      :data.type/multiplier value
      :data.type/ref-multi display-text
      :data.type/ref-single display-text
      :data.type/text-edn display-text
      :data.type/text-multiline display-text
      :data.type/text-richtext display-text
      :data.type/text-simple display-text
      :data.type/text-url display-text
      :data.type/id value
      :data.type/info nil
      (do (logging/error "No coercion for " (:field/data-type field-schema) " " (keys field-schema))
          display-text))))

(defn data-type->exceljs-type
  [data-type]
  (case data-type
    :data.type/boolean nil
    :data.type/currency-value number-formats/two-decimal-comma-period
    :data.type/currency-symbol nil
    :data.type/datetime number-formats/date-d-m-yyyy-point
    :data.type/date number-formats/date-d-m-yyyy-point
    :data.type/email-multi nil
    :data.type/email nil
    :data.type/financials nil
    :data.type/tesi-financials nil
    :data.type/tesi-financials-2 nil
    :data.type/text nil
    :data.type/integer number-formats/thousands-space
    :data.type/keyword-multi nil
    :data.type/keyword nil
    :data.type/long number-formats/thousands-space
    :data.type/number number-formats/thousands-space
    :data.type/percentage number-formats/two-decimal-percentage-period
    :data.type/multiplier number-formats/two-decimal-comma-period
    :data.type/ref-multi nil
    :data.type/ref-single nil
    :data.type/text-edn nil
    :data.type/text-multiline nil
    :data.type/text-richtext nil
    :data.type/text-simple nil
    :data.type/text-url nil
    :data.type/id "#"
    :data.type/info nil
    (do (logging/error "No exceljs type for data-type : " data-type)
        nil)))

(defn to-exceljs-type
  [attribute field-schema]
  (let [data-type (:field/data-type field-schema)]
    (if-not data-type
      (do (logging/error "No exceljs type for " (:field/data-type field-schema) " << " attribute)
          nil)
      (data-type->exceljs-type data-type))))
